import { Switch } from 'antd'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'

import styles from './pure-switcher.module.scss'

type SwitcherPosition = 'left' | 'right'

interface SwitcherProps {
  label?: string[]
  colClass?: string
  className?: string
  moduleStyle?: string
  isChecked?: boolean
  position?: SwitcherPosition
  onChange?: (value: boolean) => void
}

export const PureSwitcher: React.FC<SwitcherProps> = ({
  label = null,
  isChecked,
  className,
  colClass,
  moduleStyle,
  onChange,
  position = 'right',
}) => {
  const [checked, setChecked] = useState(isChecked)

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  const onSwitchChange = (checked: boolean) => {
    setChecked(checked)
    onChange?.(checked)
  }

  return (
    <div className={clsx('align-items-center', className, colClass || 'col-12', moduleStyle || '', styles.switcherSyles, 'p-2 mt-1 d-flex')}>
      {label && position === 'right' ? <div className="d-block">{checked ? label[0] : label[1]}</div> : null}
      <Switch
        checked={checked}
        className={clsx({
          'ml-1': position === 'right',
        })}
        onChange={onSwitchChange}
        defaultChecked
      />
      {label && position === 'left' ? <div className="d-block ms-2">{checked ? label[0] : label[1]}</div> : null}
    </div>
  )
}
